import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appStartWithZero]'
})
export class StartWithZeroDirective {

  constructor(private control: NgControl, private el: ElementRef) { }

  @HostListener('input', ['$event']) onChange() {
    const controlName = this.control.control;
    const value = this.el.nativeElement.value;
    if (value) {
      const process = value.replace(/^0*/, '');
      if (value && value !== process) {
        controlName.setValue(process)
      }
    }
  }

}
